import { CompanyLogos } from "@vega-core/components/CompanyLogos/CompanyLogos";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

const VEGA_URL = "https://www.vega-alts.com";

type PoweredByVegaProps = {
  isCollapsed: boolean;
};

export const PoweredByVega = ({ isCollapsed }: PoweredByVegaProps) => (
  <a
    aria-label="Powered by Vega"
    className={cnTwMerge("flex flex-col gap-1", isCollapsed && "items-center")}
    data-testid="powered-by-vega"
    href={VEGA_URL}
    rel="noopener noreferrer"
    target="_blank"
  >
    {!isCollapsed && (
      <span className="body-extra-small-semibold uppercase tracking-wider text-text/sidebar/secondary">
        {m.navTitles_poweredBy()}
      </span>
    )}
    <div className="flex items-center gap-2">
      <CompanyLogos className="h-6 w-6" />
      {!isCollapsed && (
        <span className="body-small-semibold text-text/sidebar/primary">
          {m.navTitles_poweredByVegaName()}
        </span>
      )}
    </div>
  </a>
);
